<template>
  <div style="padding:20px;">
    <h1>Top Cig Sales</h1>
    <DatePeriodSelector v-model="timestamps" lsComponentName='LocationTopSales' />
    
    <p>Report from {{formatDate(timestamps.from)}} to {{formatDate(timestamps.to)}}</p>
    
    <div>
      <div style="width:300px;float:left">Top :<input v-model="ls.top"></div>
      <div style="clear: left;"></div>
      <br>
      Distributor Filter:<input v-model="ls.distributorFilter">
      Include Filter:<input v-model="ls.includeFilter">
      Exclude Filter:<input v-model="ls.excludeFilter">
    </div>
    
    <div>
      <TopCigSalesTable v-model="topSalesData" :timestamps="timestamps" :qualifier="ls"/>
    </div>
  </div>

</template>

<script>
import DatePeriodSelector from '@/components/DatePeriodSelector.vue'
import TopCigSalesTable from './components/TopCigSalesTable.vue'
import CategorySelect from './components/CategorySelect.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  name: 'LocationTopCigSales',
  mixins : [localstorageMixin],
  components: {DatePeriodSelector, TopCigSalesTable, CategorySelect},
  data () { return {
    ls: {
      top : 20,
      subtypes : ['CIGS'],
      notSubtypes : [],
      includeFilter:"",
      excludeFilter:"",
      distributorFilter:"",
      willFilterDepartment: false,
    },
    topSalesData: {}, 
    timestamps: {
      from: undefined,
      to: undefined,
    },
    previousTimestamps: {
      from: undefined,
      to: undefined,
    },
    } 
  },
  watch: {
    
  },
  methods: {
    lastYear: function(date){
      return moment(date).subtract(1, 'year').add(1,'day');
    },
    formatDate: function(date, formatStyle="ddd YYYY-MM-DD h:mm a"){
      return moment(date).format(formatStyle);
    },
  },
  computed: {
    lastYearTimestamps: function(){
      const result = {...this.timestamps}
      result.from = this.lastYear(result.from)
      result.to = this.lastYear(result.to)
      return result
    }
  }
}
</script>

<style>
.selected{
  /* opacity: 0.6; */
  background-color: darkgray;
}

tr:hover {
  background-color: inherit !important;
}
tr:active, .table-striped tr:active:nth-child(even) {
color: inherit !important;
background-color: inherit !important;
}
</style>
